const prizeOdds = [
	{
		prizeCode: 0,
		name: 'Beefeater Gin & Tonic',
		percentage: 0.166,
	},
	{
		prizeCode: 1,
		name: 'Negroni',
		percentage: 0.166,
	},
	{
		prizeCode: 2,
		name: 'Garden Spritz',
		percentage: 0.166,
	},
	{
		prizeCode: 'lose',
		name: 'No win',
		percentage: 'remainder',
	},
];

export default prizeOdds;
